import {IFeature_CONO} from "../types";

export function createFeatureCollection (features: IFeature_CONO[]) {
    return {
        type: 'FeatureCollection',
        features,
        properties: {},
    };
}